/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ session: NonNullable<unknown>, place: NonNullable<unknown> }} Plan_Build_Organize_Moved_LiveInputs */

const en_us2_plan_build_organize_moved_live = /** @type {(inputs: Plan_Build_Organize_Moved_LiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.session} is now number ${i?.place}`)
};

const pt_br2_plan_build_organize_moved_live = /** @type {(inputs: Plan_Build_Organize_Moved_LiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.session} agora é o ${i?.place}º`)
};

const es_419_plan_build_organize_moved_live = /** @type {(inputs: Plan_Build_Organize_Moved_LiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.session} ahora es el número ${i?.place}`)
};

const pt_pt2_plan_build_organize_moved_live = /** @type {(inputs: Plan_Build_Organize_Moved_LiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.session} é agora o ${i?.place}.º`)
};

const fr_fr2_plan_build_organize_moved_live = /** @type {(inputs: Plan_Build_Organize_Moved_LiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.session} est maintenant en position ${i?.place}`)
};

const de_de2_plan_build_organize_moved_live = /** @type {(inputs: Plan_Build_Organize_Moved_LiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.session} ist jetzt Nummer ${i?.place}`)
};

const it_it2_plan_build_organize_moved_live = /** @type {(inputs: Plan_Build_Organize_Moved_LiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.session} ora è il numero ${i?.place}`)
};

/**
* | output |
* | --- |
* | "{session} is now number {place}" |
*
* @param {Plan_Build_Organize_Moved_LiveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_organize_moved_live = /** @type {((inputs: Plan_Build_Organize_Moved_LiveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Organize_Moved_LiveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_organize_moved_live(inputs)
	if (locale === "es-419") return es_419_plan_build_organize_moved_live(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_organize_moved_live(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_organize_moved_live(inputs)
	if (locale === "de-DE") return de_de2_plan_build_organize_moved_live(inputs)
	if (locale === "it-IT") return it_it2_plan_build_organize_moved_live(inputs)
	return en_us2_plan_build_organize_moved_live(inputs)
});
export { plan_build_organize_moved_live as "plan-build.organize_moved_live" }